import { Modal } from "react-bootstrap";
import { CartFill, ArrowRepeat } from "react-bootstrap-icons";
import { HeaderText } from "./HeaderText";
import { Button } from "./Button";

export interface BillingInfoModalProps {
    show: boolean;
    setShow: (b: boolean) => void;
}

export function BillingInfoModal({ show, setShow }: BillingInfoModalProps) {
    return (
        <Modal show={show} centered>
            <Modal.Header closeButton onHide={() => setShow(false)}>
                <HeaderText>When will I be charged?</HeaderText>
            </Modal.Header>
            <Modal.Body className="d-flex flex-column gap-3 px-4 py-4">
                <div className="d-flex align-items-start gap-3">
                    <div className="rounded-3 flex-shrink-0 d-flex align-items-center justify-content-center text-white"
                         style={{ width: 40, height: 40, backgroundColor: 'var(--color-mid)' }}>
                        <CartFill />
                    </div>
                    <div>
                        <div className="fw-semibold">At checkout</div>
                        <div className="text-muted small">When you select this payment method and complete a purchase, your card is charged immediately.</div>
                    </div>
                </div>
                <div className="d-flex align-items-start gap-3">
                    <div className="rounded-3 flex-shrink-0 d-flex align-items-center justify-content-center text-white"
                         style={{ width: 40, height: 40, backgroundColor: 'var(--color-mid)' }}>
                        <ArrowRepeat />
                    </div>
                    <div>
                        <div className="fw-semibold">On a recurring plan</div>
                        <div className="text-muted small">If you link this card to a monthly plan, it will be charged automatically on your next renewal date.</div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button className="w-100" type="button" onClick={() => setShow(false)}>
                    Got it
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
